import { Http } from '@angular/http';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
@Injectable()
export class GamesService {
 host: string;
 host2: string;
  constructor( private http:HttpClient) {

    if(location.hostname=='localhost'){
      this.host="http://localhost/playit-admin/API/public/api/v1/";
    }
    else {
      this.host = "http://api.playit.mobi/api/v1/";
    }
    this.host = "http://api.playit.mobi/api/v1/";
    this.host2 = "http://api.playit.mobi/api/v2/";
   }

  getgames( id=null){
    console.log('kdkdkdk',id);
     if(id==null){
    return this.http.get(`${this.host}games/getList`).map(result=> result)}
    else {
      return this.http.get(`${this.host}games/getList/${id}`).map(result=> result)
    }
  }
  getMygames(id){
    return this.http.get(`${this.host}admin/games/getgames/${id}`).map(result=> result)
  }

  getMygamesOpreators(){
    return this.http.get(`${this.host2}playit/operators`).map(result=> result)
  }
  

  // FAQ  send new question
  NewFaq(data){
    return this.http.post(`${this.host2}backend/faqs`,data);
  }
    // FAQ  get all question
  getAllFaq(){
    return this.http.get(`${this.host2}backend/faqs`);
  }
  // FAQ  update question
  updateFaq(id,data){
    return this.http.post(`${this.host2}backend/faqs/update/${id}`,data);
  }
  // FAQ  delete question
  deletaFaq(id){
    return this.http.delete(`${this.host2}backend/faqs/${id}`);
  }


  // FAQ  send new question
  NewTerms(data){
    return this.http.post(`${this.host2}backend/terms`,data);
  }
    // FAQ  get all question
  getAllTerms(){
    return this.http.get(`${this.host2}backend/terms`);
  }
  // Terms  update question
  updateTerms(id,data){
    return this.http.post(`${this.host2}backend/terms/update/${id}`,data);
  }
  // Terms  delete question
  deletaTerm(id){
    return this.http.delete(`${this.host2}backend/terms/${id}`);
  }

 // FAQ  get all question
 getAllVendors(){
  return this.http.get('http://api.playit.mobi/api/v1/admin/getallDeveloperUsers');
}
  //addgame
  addGame(data){
    return this.http.post(`${this.host}games/addnew`,data).map(result=>result);
  }
   //editgame
   editGame(data){
    return this.http.post(`${this.host}admin/editgame`,data).map(result=>result);
  }
  //gamelist

   //get game data
   getGameData(id){
    return this.http.get(`${this.host}admin/games/gamedata/`+id).map(result=>result)

  }


    //get system counter
    getCounters(){
      return this.http.get(`${this.host}system/counters`).map(result=>result)

    }

    //get system counter
    disactiveGame(game_id){
      return this.http.get(`${this.host}admin/disactivegame/${game_id}`).map(result=>result)

    }
     //active game
     activeGame(game_id){
      return this.http.get(`${this.host}admin/activegame/${game_id}`).map(result=>result)

    }
    //get games request
    GamesRequest(){
      return this.http.get(`${this.host}admin/games/GamesReqeust`).map(result=>result)

    }
    //delete Game
    deleteGame(game_id){
      return this.http.get(`${this.host}admin/games/delete/${game_id}`).map(result=>result)
    }


    //world cub game
    addWorldGame(game_id){
      return this.http.get(`${this.host}admin/games/addWorld/${game_id}`).map(result=>result)
    }

    //world cub game
    deleteWorldGame(game_id){
      return this.http.get(`${this.host}admin/games/deleteWorld/${game_id}`).map(result=>result)
    }



      //add exclusive game
      addExclusiveGame(game_id){
        return this.http.put(`${this.host}admin/games/addExclusive/${game_id}`,null).map(result=>result)
      }

      //delete exclusive game
      deleteExclusiveGame(game_id){
        return this.http.put(`${this.host}admin/games/deleteExclusive/${game_id}`,null).map(result=>result)
      }


    //add feature game
    addFeautreGame(game_id,action){
      return this.http.post(`${this.host}admin/games/feature/${game_id}/${action}`,null).map(result=>result)
    }

    //delete feature game
    deleteFeautreGame(game_id,action){
      return this.http.delete(`${this.host}admin/games/feature/${game_id}/${action}`).map(result=>result)
    }


// status game
setActiveStatusGame(game_id){
  return this.http.get(`${this.host}admin/activegame/${game_id}`).map(result=>result)
}

setDisactiveStatusGame(game_id){
  return this.http.get(`${this.host}admin/disactivegame/${game_id}`).map(result=>result)
}



      //world cub game
      addSliderGame(game_id){
        return this.http.get(`${this.host}admin/games/addSlider/${game_id}`).map(result=>result)
      }

      //world cub game
      deleteSliderGame(game_id){
        return this.http.get(`${this.host}admin/games/deleteSlider/${game_id}`).map(result=>result)
      }

    //get system counter
    addUser(data){
      return this.http.post(`${this.host}addNewvendor`,data).map(result=>result)

    }
     //get system counter
     approveComment(data){
      return this.http.get(`${this.host}admin/approvecomment/${data}`).map(result=>result)

    }
     //get system counter
     deleteComment(data){
      return this.http.get(`${this.host}admin/deletecomment/${data}`).map(result=>result)

    }
      //get all cats
      getAllCats(){
        return this.http.get(`${this.host}admin/getallCat`).map(result=>result)

      }

  //get all cats
  getAllSources(){
    return this.http.get(`${this.host}admin/getallDeveloperUsers`).map(result=>result)

  }
      //savecate

      updateCat(data){

        return this.http.post(`${this.host}admin/updateCat`,data);

      }
       //Add new

       NewCat(data){

        return this.http.post(`${this.host}admin/newCat`,data);

      }
      // search by cat vendor
      catGames(data){

        return this.http.post(`${this.host}admin/CatGames`,data);

      }


  getSearchGames(data){

    return this.http.post(`${this.host}admin/getSearchGames`,data);

  }
}



// WEBPACK FOOTER //
// D:/xampp/htdocs/playitadmin_frontend/src/app/Services/games.service.ts